<template>
  <div class="modal-container" ref="modalContainer">
    <div class="form-content-body">
      <div class="row">
        <div
            class="col-md-12 text-center modal-header px-4 align-items-center"
        >
          <div class="header-container row w-100">
            <h3 class="col-11 text-left ml-3">Accounts Payable admin view</h3>
            <button class="close close-btn text-right col-1" @click="closePopup">
              <img src="../../assets/images/icon-close.svg">
            </button>
          </div>
        </div>
      </div>

      <div class="main-title mx-4 mt-3 ">
        Enter the details of the user
      </div>
      <div class="my-4 popup-div">
        <help-hub-user-search
            :env="appEnv"
            @onUserSelected="onRequestedForUserSelected"
            @onUserRemoved="clearRequestedForUser"
            autocomplete="nope"
            :selected-users="requestedForUser"
            ref="userSearch"
        />
      </div>

      <div v-if="this.viewingAPUserDataFor" class="align-return-btn">
        <a class="solution-link" @click="closePopupAndReturnToYourInvoicePO">Return to your purchase orders/invoices </a>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from "../../store/constants";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "APUserSelectModal",
  data(){
    return{
      appEnv: CONSTANTS.ENV,
      requestedForUser: {},
    }
  },
  computed :{
    ...mapGetters(["currentUser","viewingAPUserDataFor"])
  },
  methods :{
    ...mapActions(["fetchAdskContactInfo"]),
    onRequestedForUserSelected(user){
      this.closePopup(user)
    },
    clearRequestedForUser(){
      this.fetchAdskContactInfo(this.currentUser.userName)
    },
    closePopup(user){
      let userDetails = user.detail
      userDetails ? this.$parent.$emit('closeAfterSelected',userDetails) : this.$parent.$emit('close');
    },
    closePopupAndReturnToYourInvoicePO(){
      this.$parent.$emit('closeAndDisplayYourPOInvoice');
    }
  },

}
</script>

<style scoped>

.popup-div{
  width: 94%;
  margin-left:23px;
}


.modal-container {
  height: 100%;
}

@media screen and (max-width: 576px) {
  .popup-div {
    height: 200px;
    width: 300px;
    margin-top: 3rem;
  }
  .align-return-btn{
    margin-top:-70px;
    margin-left: 30px;
  }
}
@media screen and (min-width: 577px){
  .align-return-btn{
    margin-left: 30px;
    margin-top: 100px;
  }
}


</style>